import * as d3 from 'd3'
import React from 'react'
import ReactDOM from 'react-dom'

export default class PiaGraph extends React.Component {
  constructor(props) {
    super(props)
    this.drawPia = this.drawPia.bind(this)

    this.height = 100
    this.width = 100
    this.radius = Math.min(this.width, this.height) / 2
  }

  componentDidUpdate() {
    this.drawPia()
  }

  componentDidMount() {
    this.drawPia()
  }

  drawPia() {
    const { data } = this.props

    // const colorRgb = data.map(b => 'rgb(' + b.RED + ',' + b.GREEN + ',' + b.BLUE + ')')

    // const color = d3.scaleOrdinal(colorRgb)
    // let ci=data.map(d=>({}))
    /*
var color = d3.scale.ordinal()
  .domain(["Lorem ipsum", "dolor sit", "amet", "consectetur", "adipisicing", "elit", "sed",
   "do", "eiusmod", "tempor", "incididunt"])
	.range(["#98abc5", "#8a89a6", "#7b6888", "#6b486b", "#a05d56", "#d0743c", "#ff8c00"]);
    */

    // const item = data.map(d => d.ITEM)
    const dataColor = data.map(b => ({
      ...b,
      color: 'rgb(' + b.RED + ',' + b.GREEN + ',' + b.BLUE + ')',
    }))

    // const color = d3
    //   .scaleOrdinal()
    //   .domain()
    //   .range(itemColor)

    const svg = d3.select(this.refs.svg_piagraph)
    svg.selectAll('*').remove()
    const g = svg
      .append('g')
      .attr('transform', 'translate(' + this.height / 2 + ',' + this.width / 2 + ')')

    const pie = d3
      .pie()
      .value(d => d.PERCENT)
      // .startAngle(d => d.startAngle + Math.PI / 2)
      // .endAngle(d => d.endAngle + Math.PI / 2)
      // .padAngle(0.01)
      .startAngle(0)
    // .endAngle(180)
    const path = d3
      .arc()
      .innerRadius(0)
      .outerRadius(this.radius)
    const arc = g
      .selectAll('.arc')
      .data(pie(dataColor))
      .enter()
      .append('g')
      .attr('class', 'arc')

    arc
      .append('path')
      .attr('d', path)
      .attr('fill', d => d.data.color)
      .attr('item', d => d.data.ITEM)
  }

  render() {
    return (
      <div style={{ ...this.props.style, display: 'grid', justifyContent: 'center' }}>
        <svg
          ref="svg_piagraph"
          height={this.height}
          width={this.width}
          // style={{ backgroundColor: 'yellow' }}
        />
      </div>
    )
  }
}
